import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { usePersistentNavigate } from '../utils/navigation';

const RegistrationResult: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = usePersistentNavigate();
    const success = searchParams.get('success') === 'true';
    const type = searchParams.get('type') || 'admin';

    const getEntityName = () => {
        switch (type) {
            case 'reviewer':
                return 'reviewer';
            case 'admin':
            default:
                return 'admin';
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper sx={{ p: 4, mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {success ? (
                    <CheckCircleIcon sx={{ fontSize: 60, color: 'success.main' }} />
                ) : (
                    <CancelIcon sx={{ fontSize: 60, color: 'error.main' }} />
                )}
                <Typography variant="h4" component="h1" sx={{ mt: 2, mb: 2 }}>
                    {success ? 'Registration Successful' : 'Registration Failed'}
                </Typography>
                <Typography>
                    {success
                        ? `The new ${getEntityName()} has been registered.`
                        : `There was an error registering the new ${getEntityName()}.`}
                </Typography>
                <Box sx={{ mt: 4 }}>
                    <Button variant="contained" onClick={() => navigate('/admin')}>
                        Back to Admin Portal
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default RegistrationResult;
